import { useBreakpoints } from '../../../../theme/hook/useBreakpoints'
import { ProfileLink } from '../organism/ProfileLink'
import { observer } from 'mobx-react-lite'
import { DesktopHeader } from '../template/DesktopHeader'
import { MobileHeader } from '../template/MobileHeader'
import { useLocation } from 'react-router-dom'
import { NotificationLink } from '../organism/NotificationLink'
import { Mobilelayout } from 'src/component/unique/layout/MobileLayout'
import { LocalesButton } from 'src/feature/localization/component/molecule/LocalesButton'
import { TourLink } from 'src/feature/header/component/original/organism/TourLink'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'

export const WithSubscriptionHeader = observer(() => {
  const { isMd } = useBreakpoints()
  const { pathname } = useLocation()

  return (
    <>
      {isMd ? (
        <MobileHeader pathname={pathname} >
          <Mobilelayout />
          <LocalesButton />
          <TourLink />
          <NotificationLink />
          <ProfileLink />
        </MobileHeader>
      ) : (
        <DesktopHeader listProps={{ spacing: 17 }}>
          <AppBox gap={5} alignItems='center'> {/* Less gap between tour and notification */}
            <LocalesButton />
            <TourLink />
            <NotificationLink />
          </AppBox>
          <ProfileLink />
        </DesktopHeader>
      )}
    </>
  )
})
